import { render } from "./RegisterRetailerModalPCP.vue?vue&type=template&id=7e3bdfee"
import script from "./RegisterRetailerModalPCP.vue?vue&type=script&lang=ts"
export * from "./RegisterRetailerModalPCP.vue?vue&type=script&lang=ts"
script.render = render

export default script